export default "__VITE_ASSET__NTAXdO9F__"